module.exports = __webpack_public_path__ + "img/web3.0844ae81.png";